// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userInfoWrapper__nt4De {
  display: flex;
  align-items: center;
}

.userInfoImage__eylta {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
}
@media (max-width: 850px) {
  .userInfoImage__eylta {
    width: 50px;
    height: 50px;
  }
}

.userInfo__Rwl_K {
  margin-left: 23px;
}

.userInfoName__kT0FD {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: var(--tables-title-text);
  padding-bottom: 10px;
  display: flex;
  align-items: center;
}

.userStatusBlock__cao0t {
  margin-left: 10px;
}

.userInfoStatus__Q4lFa {
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  text-align: center;
  text-transform: lowercase;
  padding: 2px 12px 1px;
  background-color: transparent;
  border-radius: 10px;
  border: 1px solid;
}

.userInfoStatusActive__n00ZV {
  color: var(--labels-outline-stroke-text-success);
  border-color: var(--labels-outline-stroke-text-success);
}

.userInfoStatusInactive__OKQwt {
  color: var(--labels-outline-stroke-text-critical);
  border-color: var(--labels-outline-stroke-text-critical);
}

.userInfoStatusUnconfirmed__vFhKg {
  color: var(--labels-outline-stroke-text-high);
  border-color: var(--labels-outline-stroke-text-high);
}

.btnPhotoChange__lNX0b {
  font-size: 12px;
  line-height: 12px;
  color: var(--buttons-surface) !important;
  text-decoration: none;
  background-color: transparent;
  border: none !important;
  cursor: pointer;
}

.userEmailInfo__I_Wrz {
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  color: var(--tables-secondary-row-sub-title-text);
  display: flex;
  align-items: center;
}

.emailIcon__TTtUL {
  margin-right: 9px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/UserModal/components/Avatar/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;AAzEF;AA2EE;EAPF;IAQI,WAAA;IACA,YAAA;EAxEF;AACF;;AA2EA;EACE,iBAAA;AAxEF;;AA2EA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AAxEF;;AA2EA;EACE,iBAAA;AAxEF;;AA2EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;AAxEF;;AA2EA;EACE,gDAAA;EACA,uDAAA;AAxEF;;AA2EA;EACE,iDAAA;EACA,wDAAA;AAxEF;;AA2EA;EACE,6CAAA;EACA,oDAAA;AAxEF;;AA2EA;EACE,eAAA;EACA,iBAAA;EACA,wCAAA;EACA,qBAAA;EACA,6BAAA;EACA,uBAAA;EACA,eAAA;AAxEF;;AA2EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAAA;EACA,aAAA;EACA,mBAAA;AAxEF;;AA2EA;EACE,iBAAA;AAxEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.userInfoWrapper {\n  display: flex;\n  align-items: center;\n}\n\n.userInfoImage {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  object-fit: cover;\n  object-position: center;\n\n  @media (max-width: 850px) {\n    width: 50px;\n    height: 50px;\n  }\n}\n\n.userInfo {\n  margin-left: 23px;\n}\n\n.userInfoName {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 19px;\n  color: var(--tables-title-text);\n  padding-bottom: 10px;\n  display: flex;\n  align-items: center;\n}\n\n.userStatusBlock {\n  margin-left: 10px;\n}\n\n.userInfoStatus {\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  text-align: center;\n  text-transform: lowercase;\n  padding: 2px 12px 1px;\n  background-color: transparent;\n  border-radius: 10px;\n  border: 1px solid;\n}\n\n.userInfoStatusActive {\n  color: var(--labels-outline-stroke-text-success);\n  border-color: var(--labels-outline-stroke-text-success);\n}\n\n.userInfoStatusInactive {\n  color: var(--labels-outline-stroke-text-critical);\n  border-color: var(--labels-outline-stroke-text-critical);\n}\n\n.userInfoStatusUnconfirmed {\n  color: var(--labels-outline-stroke-text-high);\n  border-color: var(--labels-outline-stroke-text-high);\n}\n\n.btnPhotoChange {\n  font-size: 12px;\n  line-height: 12px;\n  color: var(--buttons-surface) !important;\n  text-decoration: none;\n  background-color: transparent;\n  border: none !important;\n  cursor: pointer;\n}\n\n.userEmailInfo {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--tables-secondary-row-sub-title-text);\n  display: flex;\n  align-items: center;\n}\n\n.emailIcon {\n  margin-right: 9px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userInfoWrapper": `userInfoWrapper__nt4De`,
	"userInfoImage": `userInfoImage__eylta`,
	"userInfo": `userInfo__Rwl_K`,
	"userInfoName": `userInfoName__kT0FD`,
	"userStatusBlock": `userStatusBlock__cao0t`,
	"userInfoStatus": `userInfoStatus__Q4lFa`,
	"userInfoStatusActive": `userInfoStatusActive__n00ZV`,
	"userInfoStatusInactive": `userInfoStatusInactive__OKQwt`,
	"userInfoStatusUnconfirmed": `userInfoStatusUnconfirmed__vFhKg`,
	"btnPhotoChange": `btnPhotoChange__lNX0b`,
	"userEmailInfo": `userEmailInfo__I_Wrz`,
	"emailIcon": `emailIcon__TTtUL`
};
module.exports = ___CSS_LOADER_EXPORT___;
